import type { BureauHeatCell, BureauOverviewDTO } from '@pointage/shared';
import { FollowRow } from './FollowRow.js';
import { NewFollowCard } from './SuivisView.js';

const CELL_LABEL: Record<BureauHeatCell, string> = {
  ontime: 'fait dans l’heure', late: 'fait en retard', missed: 'manqué', none: '—',
};
const dayLabel = (d: string) => {
  const [, m, dd] = d.split('-');
  return `${Number(dd)}/${Number(m)}`;
};

export function PilotageView({ overview, onSettings }: { overview: BureauOverviewDTO; onSettings: () => void }) {
  return (
    <div className="bx-pilot">
      {!overview.hasAssignee && (
        <div className="card bx-banner" data-testid="bx-no-assignee">
          <span>
            <b>Phase pilote :</b> aucune responsable du bureau n’est désignée, donc aucun rappel ni aucune escalade ne part.
            Quand ce sera prêt, accorde « Bureau » à Lamis (Paramètres → Accès) puis désigne-la dans les réglages.
          </span>
          <button type="button" className="btn btn-sm" onClick={onSettings}>Réglages →</button>
        </div>
      )}

      <div className={overview.inbox.length ? 'card bx-list bx-inbox has-items' : 'card bx-list bx-inbox'} data-testid="bx-inbox">
        <div className="card-header">
          <div className="card-title">En attente d’une validation <span className="card-title-count">{overview.inbox.length}</span></div>
          <span className="bx-follow-meta">Ce qui bloque la responsable tant que personne n’a répondu</span>
        </div>
        {overview.inbox.length === 0 && <div className="bx-empty-row">Rien n’attend de validation.</div>}
        {overview.inbox.map((f) => <FollowRow key={f.id} f={f} canManage defaultOpen />)}
      </div>

      <div className="bx-pilot-grid">
        <div className="card bx-heat-card">
          <div className="card-header">
            <div className="card-title">Historique des journées <span className="card-title-count">10 jours ouvrés</span></div>
            <span className="bx-legend">
              <span><i className="c-ontime" />Dans l’heure</span>
              <span><i className="c-late" />En retard</span>
              <span><i className="c-missed" />Manqué</span>
            </span>
          </div>
          <div className="bx-heat-scroll">
            <table className="bx-heat">
              <thead>
                <tr>
                  <th scope="col"><span className="sr-only">Moment</span></th>
                  {overview.days.map((d) => <th scope="col" key={d} className="bx-mono">{dayLabel(d)}</th>)}
                </tr>
              </thead>
              <tbody>
                {overview.heat.map((r) => (
                  <tr key={r.momentId}>
                    <th scope="row"><span className="bx-mono">{r.time}</span> {r.label}</th>
                    {r.cells.map((c, i) => (
                      <td key={i}><span className={`bx-cell c-${c}`} title={`${dayLabel(overview.days[i]!)} · ${CELL_LABEL[c]}`} /></td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <NewFollowCard assigning />
      </div>
    </div>
  );
}
